import React from 'react';
import { arrayOf, shape } from 'prop-types';
import AUIButton from '@ancert/aui-button';
import AUISteps from '@ancert/aui-steps';
import DatosPersonales from '../../components/DatosPersonales';
import DatosComunicacion from '../../components/datosComunicacion';
import PersonasArchivos from '../../components/PersonasArchivos';
import { useFormularDenuncia } from '../../context/formularDenuncia.context';
import { STEPS, STEPS_ARRAY } from '../../lib/formularDenuncia.enum';
import DenunciaCorrecta from '../../components/DenunciaCorrecta';

const FormularDenunciaView = ({ data }) => {
  const { activeStep, goHome, onClickNext, setActiveStep, watch } = useFormularDenuncia();

  const renderContent = () => {
    if (activeStep === STEPS.DATOS_COMUNICACION) {
      return <DatosComunicacion data={data} />;
    }
    if (activeStep === STEPS.DATOS_PERSONALES) {
      return <DatosPersonales />;
    }
    if (activeStep === STEPS.PERSONAS_ARCHIVOS) {
      return <PersonasArchivos />;
    }

    return <></>;
  };

  const onClickAnterior = () => {
    setActiveStep(activeStep - 1);
  };

  const canSend =
    activeStep !== STEPS.PERSONAS_ARCHIVOS ||
    (activeStep === STEPS.PERSONAS_ARCHIVOS && watch('acceptPolicy')?.length > 0);

  return (
    <div className="o-sii-main-container">
      <div className="o-sii-main-container__exit">
        <AUIButton icon="arrowLeft" iconPos="left" label="Salir" size="lg" mode="ghost" onClick={goHome} />
      </div>
      <AUISteps className="u-p-16" steps={STEPS_ARRAY} activeIndex={activeStep - 1} />
      {activeStep !== STEPS.OK ? (
        <form onSubmit={onClickNext} autoComplete="off">
          {renderContent()}
          <div className="o-sii-main-container__buttons">
            <AUIButton
              disabled={activeStep === STEPS.DATOS_COMUNICACION}
              mode="tertiary"
              label="Anterior"
              size="lg"
              onClick={onClickAnterior}
            />
            <AUIButton
              type="submit"
              disabled={!canSend}
              label={activeStep === STEPS.PERSONAS_ARCHIVOS ? 'Enviar' : 'Siguiente'}
              size="lg"
            />
          </div>
        </form>
      ) : (
        <DenunciaCorrecta />
      )}
    </div>
  );
};

FormularDenunciaView.propTypes = {
  data: arrayOf(arrayOf(shape({}))),
};
FormularDenunciaView.defaultProps = {
  data: [],
};

export default FormularDenunciaView;
